module.exports = __webpack_public_path__ + "static/media/S12.9a31aff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/S12.png
// module id = 133
// module chunks = 0